export default __webpack_public_path__ + "static/Sketch-icon-buttons-2b63b413c210986e802def7194b02d3a.gif";